var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenRoundCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#73D053"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4997 7.85044C16.7052 7.63389 16.9844 7.51107 17.2763 7.50882C17.5683 7.50658 17.8492 7.62509 18.0577 7.83846C18.2663 8.05183 18.3854 8.34271 18.3891 8.64753C18.3929 8.95234 18.2809 9.24631 18.0777 9.46518L12.1977 17.1403C12.0967 17.2538 11.9748 17.345 11.8393 17.4083C11.7038 17.4715 11.5575 17.5057 11.4091 17.5086C11.2607 17.5115 11.1132 17.4832 10.9755 17.4253C10.8378 17.3674 10.7127 17.2811 10.6077 17.1716L6.70918 13.1027C6.50202 12.8862 6.38567 12.5928 6.38574 12.2868C6.38581 11.9808 6.50229 11.6874 6.70956 11.4711C6.91683 11.2548 7.1979 11.1333 7.49095 11.1334C7.784 11.1334 8.06502 11.2551 8.27219 11.4715L11.3554 14.6916L16.4704 7.88646C16.4797 7.87408 16.4897 7.86231 16.5004 7.85123L16.4997 7.85044Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -68.6143,
    y: -67.4912,
    width: 212.003,
    height: 210,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 25,
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRoundCheck);
export default __webpack_public_path__ + "static/media/green-round-check.7465a91f6af85cba4f86024a6d0dccf3.svg";
export { ForwardRef as ReactComponent };